import { AccountApiUrls, ApiConfig, DeviceApiUrls, EShopApiUrls } from './types';

const testDiceApiBaseUrl = 'https://warpzone-api-test.noa.nintendo.com';
const testNasApiUrl = `${testDiceApiBaseUrl}/emailornaid`;
const testDiceMulesoftProxyUrl = `${testDiceApiBaseUrl}/mulesoft-proxy`;
const testDiceGameplayProxyUrl = `${testDiceApiBaseUrl}/gameplay-proxy`;
const testNcomGraphUrl = 'https://graph.nintendo.com';

const testAccountApiUrls: AccountApiUrls = {
    accountAndDeviceDetails: (naid: string) => `${testDiceMulesoftProxyUrl}/account/${naid}`,
    gameRecommendations: (naid: string) => `${testDiceApiBaseUrl}/account/${naid}/recommendations`,
    gameSummaries: (naid: string) => `${testDiceGameplayProxyUrl}/${naid}`,
    gameSummaryDetails: (naid: string, applicationId: string) =>
        `${testDiceGameplayProxyUrl}/${naid}/title/${applicationId}`,
    partOrdersByNaid: (naid: string) =>
        `${testDiceApiBaseUrl}/partorders?naid=${naid}&sortOrder=desc`,
    partOrdersByEmail: (email: string) =>
        `${testDiceApiBaseUrl}/partorders?email=${email}&sortOrder=desc`,
    partOrdersByOrderNumber: (orderNumber: string) =>
        `${testDiceApiBaseUrl}/partorders?orderNumber=${orderNumber}`,
};

const testDeviceApiUrls: DeviceApiUrls = {
    associatedAccounts: (serialNumber: string) =>
        `${testDiceMulesoftProxyUrl}/v1_1/device/accounts/${serialNumber}`,
    deviceDetails: (serialNumber: string) =>
        `${testDiceMulesoftProxyUrl}/v1_1/device/${serialNumber}`,
    deviceRepairs: (serialNumber: string) =>
        `${testDiceMulesoftProxyUrl}/v1_1/device/repairs?serial_number=${serialNumber}&sort_order=desc&limit=3`,
    deviceRepairsByEmail: (email: string) =>
        `${testDiceMulesoftProxyUrl}/v1_1/device/repairs?email=${email}&sort_order=desc&limit=3`,
    errorCodes: () => `${testDiceMulesoftProxyUrl}/v1_1/device/error_codes`,
};

const testEShopApiUrls: EShopApiUrls = {
    purchaseHistory: (naid: string) => `${testDiceApiBaseUrl}/account/${naid}/purchase-history`,
};

export const testApiConfig: ApiConfig = {
    accountApiUrls: testAccountApiUrls,
    deviceApiUrls: testDeviceApiUrls,
    eShopApiUrls: testEShopApiUrls,
    nasUrl: testNasApiUrl,
    ncomGraphUrl: testNcomGraphUrl,
};
